import { render } from "./Receipt.vue?vue&type=template&id=270c1fd4&scoped=true&ts=true"
import script from "./Receipt.vue?vue&type=script&lang=ts"
export * from "./Receipt.vue?vue&type=script&lang=ts"

import "./Receipt.vue?vue&type=style&index=0&id=270c1fd4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270c1fd4"]])

export default __exports__